<template>
  <div class="settings-modal__overlay">
    <div class="settings-modal__body">
      <div
        class="settings-modal__items-wrapper"
        @dragover.prevent
        @dragenter.prevent="onDragEnter"
        @dragleave.prevent="onDragLeave"
        @drop.prevent="onDrop($event)"
      >
        <ImageSliderSettingsItem
          v-for="(item, index) in items"
          :id="item.id"
          :key="item.id"
          :image-src="item.src"
          :description="item.description"
          :source="item.source"
          :is-dragged="isDragged"
          draggable="true"
          :data-index="index"
          @dragstart="onDragStart($event, item, index)"
          @dragend="onDragEnd($event)"
          @update:image-src="handleItemImageUpdate"
          @update:description="handleDescriptionUpdate"
          @update:source="handleSourceUpdate"
          @rotate="handleRotate"
          @delete="handleItemDelete"
        />
        <ImageSliderSettingsItemEmptyModel
          @on-new-upload="handleNewItemsUpdate"
        />
      </div>

      <div class="settings-modal__control-buttons">
        <button class="settings-modal__control-cancel" @click="emit('close')">
          Отменить
        </button>
        <button
          class="settings-modal__control-save"
          @click="emit('save', items)"
        >
          Сохранить
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  images: { type: Array, required: true },
});

const emit = defineEmits(['save', 'close']);

const sortedIndex = ref(null);
const items = ref([]);
const isDragged = ref(false);
const counter = ref(-1);

items.value = props.images.map((item, index) => ({
  id: index + 1,
  ...item,
}));

onMounted(() => {
  document.body.style.position = 'fixed';
});

onBeforeUnmount(() => {
  document.body.style.position = '';
});

const handleNewItemsUpdate = (item) => {
  items.value = [
    ...items.value,
    { ...item, id: counter.value--, imageBase64: true },
  ];
};

const onDragStart = (e, _, index) => {
  isDragged.value = true;
  e.target.classList.add('draggable');
  e.dataTransfer.dropEffect = 'move';
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData('index', index.toString());
};

const onDragEnd = (e) => {
  isDragged.value = false;
  e.target.classList.remove('draggable');
};

const onDrop = (e) => {
  e.target.classList.remove('dragenter');
  if (sortedIndex.value >= 0) {
    const index = Number(e.dataTransfer.getData('index'));
    items.value.splice(sortedIndex.value, 0, items.value.splice(index, 1)[0]);
  }
};

const onDragEnter = (e) => {
  if (e.target && e.target.dataset.index) {
    e.target.classList.add('dragenter');
    sortedIndex.value = Number(e.target.dataset.index);
  }
};

const onDragLeave = (e) => {
  e.target.classList.remove('dragenter');
};

const getItemFromId = (id) => {
  return items.value.find((el) => el.id === id);
};

const handleItemImageUpdate = (payload) => {
  const { id, imageSrc } = payload;
  const item = getItemFromId(id);
  item.imageSrc = imageSrc;
};

const handleDescriptionUpdate = (payload) => {
  const { id, description } = payload;
  const item = getItemFromId(id);
  item.description = description;
};

const handleSourceUpdate = (payload) => {
  const { id, source } = payload;
  const item = getItemFromId(id);
  item.source = source;
};

const handleRotate = (id) => {
  const item = getItemFromId(id);
  item.rotate = item.rotate === 270 ? 0 : item.rotate + 90;
};

const handleItemDelete = (id) => {
  items.value = items.value.filter((item) => item.id !== id);
};
</script>
